import Vue from 'vue'
import Router from 'vue-router'
import SearchParcel from './views/Receive/SearchParcel.vue'
import Login from './views/Login.vue'
import ProjectSelect from './views/ProjectSelect.vue'
import MainMenu from './views/MainMenu.vue'

//Receive
import QRScan from './views/QRScan.vue'
import BarcodeScan from './views/Receive/BarcodeScan.vue'
import ParcelList from './views/Receive/ParcelList.vue'
import Receive from './views/Receive/ReceiveParcel.vue'
import CustomerReceiveParcel from './views/Receive/CustomerReceiveParcel.vue'

//ot Parcel
import OTParcelCustomer from './views/OTParcel/OTParcelCustomer.vue'
import OTParcelEmployee from './views/OTParcel/OTParcelEmployee.vue'
import OTParcelList from './views/OTParcel/OTParcelList.vue'
import GenLinkParcel from './views/OTParcel/GenLinkParcel.vue'
import OTParcelListSubmit from './views/OTParcel/OTParcelListSubmit.vue'
import OTParcelReport from './views/OTParcel/OTParcelReport.vue'

//Box24
import GetLocationBox24 from './views/Box24/GetLocationBox24.vue'
import GetSizeBox24 from './views/Box24/GetSizeBox24.vue'
import AddNewOrderBox24 from './views/Box24/AddNewOrderBox24.vue'
import BarcodeOrderBox24 from './views/Box24/BarcodeOrderBox24.vue'

//waiting parcel
import WaitingInputParcel from './views/Waiting/WaitingInputParcel.vue'
import BarcodeScanWaiting from './views/Waiting/BarcodeScanWaiting.vue'
import QRCodeScanWaiting from './views/Waiting/QRCodeScanWaiting.vue'
import SaveSuccess from './views/Waiting/SaveSuccess.vue'

//other
import EditCustomer from './views/Other/EditCustomer.vue'
import OTParcelStatus from './views/Other/OTParcelStatus.vue'
import StatusChange from './views/Other/StatusChange.vue'
import ParcelManual from './views/Other/ParcelManual.vue'

//import
import PreviewImportParcelView from './views/Import/PreviewImportParcelView.vue'

Vue.use(Router)

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {path: '/', component: Login, name: 'login', props(route) {return route.query || {} }},
        {path: '/login', component: Login, name: 'login'},
        {path: '/project', component: ProjectSelect, name: 'project'},
        {path: '/main-menu', component: MainMenu, name: 'main-menu'},

        //Receive
        {path: '/search-parcel', component: SearchParcel, name: 'search-parcel'},
        {path: '/qrscan', component: QRScan, name: 'qrscan'},
        {path: '/barcode-scan', component: BarcodeScan, name: 'barcode-scan'},
        {path: '/parcel-list', component: ParcelList, name: 'parcel-list'},
        {path: '/receive', component: Receive, name: 'receive'},
        {path: '/cus-receive/:id', component: CustomerReceiveParcel, name: 'cus-receive/:id'},

        //Ot-parcel
        {path: '/ot-parcel/:lineID/:channelID', component: OTParcelCustomer, name: 'ot-parcel/:lineID/:channelID'},
        {path: '/ot-parcel-emp', component: OTParcelEmployee, name: 'ot-parcel-emp'},
        {path: '/ot-parcel-list', component: OTParcelList, name: 'ot-parcel-list'},
        {path: '/gen-link', component: GenLinkParcel, name: 'gen-link'},
        {path: '/ot-list-submit', component: OTParcelListSubmit, name: 'ot-list-submit'},
        {path: '/ot-parcel-report', component: OTParcelReport, name: 'ot-parcel-report'},

        //box24
        {path: '/location-box24', component: GetLocationBox24, name: 'location-box24'},
        {path: '/size-box24', component: GetSizeBox24, name: 'size-box24'},
        {path: '/add-order-box24', component: AddNewOrderBox24, name: 'add-order-box24'},
        {path: '/barcode-order-box24', component: BarcodeOrderBox24, name: 'barcode-order-box24'},

        //waiting input parcel
        {path: '/waiting-parcel', component: WaitingInputParcel, name: 'waiting-parcel'},
        {path: '/barcode-scan-waiting', component: BarcodeScanWaiting, name: 'barcode-scan-waiting'},
        {path: '/qrcode-scan-waiting', component: QRCodeScanWaiting, name: 'qrcode-scan-waiting'},
        {path: '/save-success', component: SaveSuccess, name: 'save-success'},

        //other
        {path: '/edit-customer', component: EditCustomer, name: 'edit-customer'},
        {path: '/ot-parcel-status', component: OTParcelStatus, name: 'ot-parcel-status'},
        {path: '/status-change', component: StatusChange, name: 'status-change'},
        {path: '/parcel-manual', component: ParcelManual, name: 'parcel-manual'},

        //import        
        {path: '/import-parcel/:nt_runno/:username', component: PreviewImportParcelView, name: 'import-parcel'},
        
    ]
})
